import axios from "axios"
import baseURL from "../configs/api"

export const getCustomersExtraInformation = (tenantId: string) => {
    return getFetch("customerExtraInformation", tenantId);
}

export const getCustomersExtraInformationsByCustomerId = (customerId: number, tenantId: string) => {
    return getFetch(`customerExtraInformation/GetCustomerExtraInformationsByCustomerId/${customerId}`, tenantId);
}


export const getCustomerExtraInformation = (primaryKey: string, tenantId: string) => {
    return getFetch(`customerExtraInformation/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}